import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { PovegoProvider } from './context';

// import css
import "./assets/styles/index.css";
import { Provider } from "react-redux";
import { store } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PovegoProvider>
        <BrowserRouter> 
       
            <App />
        
        </BrowserRouter>
      </PovegoProvider>
    </Provider>
  </React.StrictMode>
);